
import React from 'react';
import Moment from 'react-moment';
import { Form, Field} from 'react-final-form';
import Modal from '../../widgets/Modal';
import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
import {CardSmall } from '../../widgets/Cards';
import { fetchPainTreatments, fetchPainTreatment, editPainTreatment, newPainTreatment, deletePainTreatment} from '../../../actions';

class PainTreatment extends React.Component {

    constructor(props) {
            super(props);
            this.state = {
                showModal: false,
                showDelete : false,
                newForm : true,
                record : null,
            };
        };


    //Initial Rendering
    componentDidMount() {
        this.props.fetchPainTreatments(this.props.patient._id)
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
             this.props.fetchPainTreatments(this.props.patient._id)
        }
       
    }

    // sorting data by date
    compareDate(a, b) {

        var key1 = a.date;
        var key2 = b.date;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }
    
    // Render content

    renderPainTreatmentList() {

        var list = this.props.pain_treatments;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(pain_treatment =>  {

            const rowButton = () => {
                var permit = this.props.selectedPermission.permission[0].chronicdisease;
                if (permit === "View only") {
                    return null;
                } else { 
                    return (
                        <>
                        <button onClick={() => this.setState({showModal: true, newForm: false, record: pain_treatment._id})} className='tableEdit'><i className="far fa-edit"></i></button>
                        <button onClick={() => this.setState({showDelete: true, record: pain_treatment._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                        </>
                    )
                }  
            }
//SECTION A    
            return (
                    <tr key={pain_treatment._id}>        
                        <td> <Moment format='DD MMM YYYY'>{pain_treatment.date}</Moment></td>      
                        <td>{pain_treatment.type}</td>
                        <td>{pain_treatment.issue}</td>
                        <td>{pain_treatment.treatment}</td>
                        <td>{pain_treatment.practitioner}</td>
                        <td>
                            {rowButton()}
                        </td>
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].pain;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }
//SECTION B
    render() {
        return (
                <CardSmall title='Pain Treatment' buttons={this.buttons()}>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Issue</th>
                                <th>Treatment</th>   
                                <th>Practitioner</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody> 
                            {this.renderPainTreatmentList()}
                        </tbody> 
                    </table>
                    {this.renderModalBox()}
                    {this.renderDeleteBox()}
           
                </CardSmall>
        )
    }

    //Update or New Form Pop Up

    renderModalBox() {
        const record = this.state.record;
        if (record !== null) {
           this.props.fetchPainTreatment(record);
        }

        const pain_treatmentForm = () => {
            const required = value =>(value ? undefined : 'Required');
         
            var content;
            if (this.state.newForm === false ) {
                content = this.props.selectedVaccine;
            } else {
                content = null;
            }
            const currentVax = content;

            const handleSubmit = (formValues) => {
            
                const form = formValues;
                form['patientId'] = this.props.patient._id;
                form['userId'] = this.props.userId;  

                const vaxId = form._id;
                if (vaxId === undefined) {
                    this.props.newPainTreatment(form);
                } else {
                    this.props.editPainTreatment(form, vaxId);
                }
                this.setState({showModal :false, newForm : true,record : null,});
           }

// SECTION C
            return (
                <Form 
                    onSubmit = {handleSubmit} 
                    initialValues = {currentVax}
                    render = {({ handleSubmit, pristine, form, values, submitting }) => {
                    return   (
                            <form onSubmit={handleSubmit}>
                                <Field name="date" component='input' label="Date" validate={required}>
                                    {({input, meta}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Date</label>
                                                <input size='30' {...input} type='date' />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                    )} 
                                </Field>
                                <Field name="type" component='input'>
                                    {({ input}) => (
                                        <div>
                                            <label>Type</label>
                                            <select {...input}>
                                                <option value="diagnostic">Diagnostic</option>
                                                <option value="medication">Medication</option>
                                                <option value="education">Education</option>
                                                <option value="procedure">Procedure</option>
                                                <option value="referral">Referral</option>
                                            </select>
                                        </div>
                                    )}
                                </Field>
                               <Field name='issue' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Issue</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='treatment' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Treatment/Action</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='practitioner' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Practitioner/Provider</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                   
                                <div className='modalButton'>
                                    <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                    <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                    <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                                </div>
                                
                            </form>
                        )
                    }}
                />
            )
        }   
        //  <pre>{JSON.stringify(values, 0, 2)}</pre>

// main render

// SECTION D
        return (
            <Modal 
                height='340px'
                width='300px'
                open={this.state.showModal} 
                title='Pain Treatment'
                data={this.state.record}
                content={pain_treatmentForm()}
                onDismiss={() => this.setState({showModal: false, record: null})}
            />
        )
    }

    //Delete confirmation pop up
    renderDeleteBox() {

        const handleDelete = () => {
            this.props.deletePainTreatment(this.state.record);
            this.setState({showDelete:false, record:null})
        }

        const deleteButtons = () => {
            return (
            <div>
                <button onClick={() => this.setState({showDelete: false})} className='btdel'>Cancel</button>
                <button onClick={handleDelete} className='btsave'>Ok</button>
            </div>
            )
        }

//SECTION E
        return (
            <Confirm
            height='100px'
            width='300px'
            open={this.state.showDelete} 
            data={this.state.record}
            content="Delete this Pain Treatment ?"
            title='Delete Pain Treatment'
            actions = {deleteButtons()}
            onDismiss={() => this.setState({showDelete : false, record:null})}
        />
        )

    }

}


const mapStateToProps = (state) => {
    return { 
        contents : state.selectedPatient,
        pain_treatments : Object.values(state.pain_treatments),
        patient : state.selectedPatient,
        userId : state.auth.userId,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchPainTreatments, fetchPainTreatment, editPainTreatment, newPainTreatment, deletePainTreatment})(PainTreatment);



